module.exports = function (text, value, options) {
  return text.indexOf(value) === 0 ? options.fn(this) : options.inverse(this);
};
